import { graphql } from '@/generated/gql';

export const DEMAND_CASES_RELEASE_QUERY = graphql(/* GraphQL */ `
  query DemandCasesRelease($id: UUID!) {
    tesseract {
      demand(id: $id) {
        id
        negotiationCases {
          nodes {
            id
            sequenceNumber
            status
            variant
            createdAt
            updatedAt
            supplier {
              id
              internalId
              name
              location {
                id
                internalId
                address
                city
                countryCode
                postalCode
              }
              contact {
                id
                internalId
                email
                firstName
                lastName
                language
                phone
                mobile
              }
            }
            isReleasable
            processSteps {
              variant
              status
            }
          }
        }
      }
    }
  }
`);
